import * as React from 'react';
import { ApSimpleDropdown } from '@alixpartners/ui-components';
import { CompareYearTable } from 'components/Tables/CompareYearTable';
import { ApiContext } from 'context/ApiContext';
import {
  ICompareYearTableRow,
  ICurrencyFormat,
  IHeadlinesResponse,
} from 'utils/types';
import { SectionWrapper, HeaderLabel, HeaderTop } from './Analysis.styles';
import { EXPORT_OPTIONS } from 'utils/constants';

const getData = (headlines: IHeadlinesResponse): ICompareYearTableRow[] => {
  const {
    comparisonPeriod,
    currentPeriod,
    numberOfEmployeesVariance,
    numberOfUniqueGeographiesVariance,
    numberOfUniqueVendorsVariance,
    revenueVariance,
    totalCostAsPercentageOfRevenueVariance,
    totalCostVariance,
  } = headlines;
  const data = [
    {
      year: {
        startDate: currentPeriod.startDate,
        endDate: currentPeriod.endDate,
      },
      spend: currentPeriod.totalCost,
      revenue: currentPeriod.revenue,
      percentageRevenue: currentPeriod.totalCostAsPercentageOfRevenue,
      headcount: currentPeriod.numberOfEmployees,
      vendors: currentPeriod.numberOfUniqueVendors,
      geographies: currentPeriod.numberOfUniqueGeographies,
    },
    {
      year: {
        startDate: comparisonPeriod.startDate,
        endDate: comparisonPeriod.endDate,
      },
      spend: comparisonPeriod.totalCost,
      revenue: comparisonPeriod.revenue,
      percentageRevenue: comparisonPeriod.totalCostAsPercentageOfRevenue,
      headcount: comparisonPeriod.numberOfEmployees,
      vendors: comparisonPeriod.numberOfUniqueVendors,
      geographies: comparisonPeriod.numberOfUniqueGeographies,
    },
    {
      year: {
        startDate: '',
        endDate: '',
      },
      spend: totalCostVariance,
      revenue: revenueVariance,
      percentageRevenue: totalCostAsPercentageOfRevenueVariance,
      headcount: numberOfEmployeesVariance,
      vendors: numberOfUniqueVendorsVariance,
      geographies: numberOfUniqueGeographiesVariance,
    },
  ];
  return data;
};

const HeadlineView = ({
  downloadSpendHeadlineData,
  format,
  headlines,
  showSuccessNotification,
}: {
  downloadSpendHeadlineData: () => Promise<any>;
  format: ICurrencyFormat;
  headlines: IHeadlinesResponse;
  showSuccessNotification: () => void;
}) => {
  if (!headlines) {
    return null;
  }
  return (
    <SectionWrapper>
      <HeaderTop>
        <HeaderLabel>Headlines</HeaderLabel>
        <ApSimpleDropdown
          iconName="outline_save_alt"
          onChange={(s: any) => {
            if (s.value === 'xlsx') {
              downloadSpendHeadlineData().then(showSuccessNotification);
            }
          }}
          options={[EXPORT_OPTIONS[1]]}
          label="Export"
        />
      </HeaderTop>
      <CompareYearTable data={getData(headlines)} format={format} />
    </SectionWrapper>
  );
};

export default (props: any) => (
  <ApiContext.Consumer>
    {({ format }) => <HeadlineView {...props} format={format} />}
  </ApiContext.Consumer>
);
